const dev = {
	apiGateway: {
		apiUrl: 'https://localhost:44370/api/v3.1/',
	},
	appSetting: {
		baseUrl: 'http://localhost:3000/',
	},
	phTermsAndConditionsUrl: 'http://localhost:8080/legal/termsandconditions',
	apiReferenceDocUrl: 'https://docs.sandbox.packagehub.mec.maersk.com/userguide/',
	googleCaptchaKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
	reCaptchaStatus: 'Enabled', // Enabled, Bypass, Disabled
	USPSFulfillmentTierName: 'Fulfillment',
};

const qa = {
	apiGateway: {
		apiUrl: 'https://packagehub-api-qa.visiblescm.com/portal/api/v3.1/',
	},
	appSetting: {
		baseUrl: 'https://portal.sandbox.packagehub.mec.maersk.com/',
	},
	phTermsAndConditionsUrl: 'https://sandbox.packagehub.mec.maersk.com/legal/termsandconditions',
	apiReferenceDocUrl: 'https://docs.sandbox.packagehub.mec.maersk.com/userguide/',
	googleCaptchaKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
	reCaptchaStatus: 'Enabled', // Enabled, Bypass, Disabled
	USPSFulfillmentTierName: 'FulfillmentConfig',
};

const prod = {
	apiGateway: {
		apiUrl: 'https://packagehub-api.visiblescm.com/portal/api/v3.1/',
	},
	appSetting: {
		baseUrl: 'https://portal.packagehub.mec.maersk.com/',
	},
	phTermsAndConditionsUrl: 'https://packagehub.mec.maersk.com/legal/termsandconditions',
	apiReferenceDocUrl: 'https://docs.packagehub.mec.maersk.com/userguide/',
	googleCaptchaKey: '6LcLUTEaAAAAAD9JKR6FObXstZWs3t87RkyPhsok',
	reCaptchaStatus: 'Enabled', // Enabled, Bypass, Disabled
	USPSFulfillmentTierName: 'FulfillmentConfig',
};

const common = {};

let config = dev;

switch (process.env.REACT_APP_ENV) {
	case 'qa':
		config = qa;
		break;
	case 'prod':
		config = prod;
		break;
}

export default {
	...common,
	...config,
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts